export { getPartThumbnail } from "@shared/utils/getPartThumbnail";

/**
 * Get normalized currency with fallback to EUR
 * @param {string|null|undefined} currency - The currency from OEM settings
 * @returns {string} Normalized uppercase currency code (defaults to EUR)
 */
export const getNormalizedCurrency = (currency) => {
  return currency ? String(currency).toUpperCase() : "EUR";
};
